import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { StaticImage } from "gatsby-plugin-image";

function Brandsuk() {
  return (
    <section className="brands_uk brands-uk-web">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="mobile-uk-view">
              <Swiper
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                modules={[Autoplay]}
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                  },
                }}
                className="brands_logo_slider"
              >
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/business_com.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={283}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/forbes.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={211}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/the_sun.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={138}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/inc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={151}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/nbc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={62}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brands_logo_app_item">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/press_wire.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={246}
                      height={60}
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>

            <div className="desktop_view_uk">
              <div className="brands-uk-web-main">
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/business_com.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={283}
                      height={60}
                    />
                  </div>
                </div>
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/forbes.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={211}
                      height={60}
                    />
                  </div>
                </div>
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/the_sun.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={138}
                      height={60}
                    />
                  </div>
                </div>
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/inc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={151}
                      height={60}
                    />
                  </div>
                </div>
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/nbc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={62}
                      height={60}
                    />
                  </div>
                </div>
                <div className="brands-uk-main-item">
                  <div className="brands-web-img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/brands/press_wire.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={246}
                      height={60}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Brandsuk;
